import React from "react";
import { Link } from "react-router-dom";
import "../components/css/Projects.css";

const Allprojects: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen bg-[#F4F1EC]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-16 py-20">
        <div className="mt-28 text-center">
          <h2 className="about-title text-5xl">All Projects</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mt-20">
          {/* Project 1 */}
          <Link to="/projects/slowisfast" className="group flex flex-col">
            <div className="overflow-hidden rounded-2xl transition-all duration-300 group-hover:-translate-y-1">
              <img src="/sif-card.png" alt="SlowisFast" className="w-full h-auto object-cover" />
            </div>
            <div className="pt-4 pb-2">
              <h3 className="text-2xl font-semibold">SlowisFast</h3>
              <p className="text-base text-gray-500 mt-1">UX / Product Design</p>
            </div>
          </Link>

          {/* Project 2 */}
          <Link to="/projects/infosafe" className="group flex flex-col">
            <div className="overflow-hidden rounded-2xl transition-all duration-300 group-hover:-translate-y-1">
              <img src="/card2.png" alt="InfoSafe Application" className="w-full h-auto object-cover" />
            </div>
            <div className="pt-4 pb-2">
              <h3 className="text-2xl font-semibold">InfoSafe</h3>
              <p className="text-base text-gray-500 mt-1">Web Design</p>
            </div>
          </Link>

          {/* Project 3 */}
          <Link to="/projects/witness" className="group flex flex-col">
            <div className="overflow-hidden rounded-2xl transition-all duration-300 group-hover:-translate-y-1">
              <img src="/card3.png" alt="Urban Legend Application" className="w-full h-auto object-cover" />
            </div>
            <div className="pt-4 pb-2">
              <h3 className="text-2xl font-semibold">Urban Legend</h3>
              <p className="text-base text-gray-500 mt-1">UI & UX</p>
            </div>
          </Link>
        </div>

        {/* Other Projects Section */}
        <div className="grid grid-cols-1 gap-12 mt-20">
          <Link to="/otherp" className="group flex flex-col" onClick={scrollToTop}>
            <div className="overflow-hidden rounded-2xl transition-all duration-300 group-hover:-translate-y-1">
              <img
                src="/cardall.png"
                alt="Brand Design"
                className="w-full h-auto"
              />
            </div>
            <div className="pt-4 pb-2">
              <h3 className="text-2xl font-semibold">Celeste's Other Projects</h3>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Allprojects;
